export default __webpack_public_path__ + "static/media/waybill.1d5ac839.hbs";